import { ScreenStateType } from './types';
import { ReduxAction } from 'app/redux/types';


export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';

export type SetWindowSizeActionType = ReduxAction<typeof SET_WINDOW_SIZE, ScreenStateType>;

export const setWindowSize = (
  innerWidth: number,
  innerHeight: number,
): SetWindowSizeActionType => ({
  type: SET_WINDOW_SIZE,
  payload: { innerWidth, innerHeight },
});
